var _styled;

// References:
// https://github.com/alphagov/govuk-frontend/tree/master/src/components/back-link
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BLACK, YELLOW } from 'govuk-colours';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants'; // const Button

var Anchor = styled('button')((_styled = {
  fontFamily: NTA_LIGHT,
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  fontWeight: 400,
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled.display = 'inline-block', _styled.position = 'relative', _styled.marginTop = '15px', _styled.paddingLeft = '14px', _styled.border = 0, _styled.color = "" + BLACK, _styled.borderBottom = "1px solid " + BLACK, _styled.textDecoration = 'none', _styled['::before'] = {
  display: 'block',
  width: 0,
  height: 0,
  borderStyle: 'solid',
  borderColor: 'transparent',
  clipPath: 'polygon(0% 50%, 100% 100%, 100% 0%)',
  borderWidth: '5px 6px 5px 0',
  borderRightColor: "" + BLACK,
  content: "''",
  position: 'absolute',
  top: '-1px',
  bottom: '1px',
  left: 0,
  margin: 'auto'
}, _styled[':focus'] = {
  backgroundColor: "" + YELLOW,
  outline: "3px solid " + YELLOW
}, _styled));

var BackLink = function BackLink(_ref) {
  var children = _ref.children,
      className = _ref.className,
      goBack = _ref.goBack;
  return React.createElement(Anchor, {
    className: className,
    onClick: goBack
  }, children);
};

BackLink.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Generally the text that will appear in the back link
   */
  children: PropTypes.node.isRequired,

  /**
   * A function that is called on click
   */
  goBack: PropTypes.func,
  // TODO: rename onClick
  className: PropTypes.string
} : {};
BackLink.defaultProps = {
  goBack: undefined,
  className: undefined
};
export default withWhiteSpace({
  marginBottom: 3
})(BackLink);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/back-link/es/index.js
// module id = 58
// module chunks = 0